import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function HoursAvailableSkeleton() {
    return (
        <>
            <Stack spacing={1} mb={2}>
                <Skeleton animation="wave" variant="rectangular" height={45} />
                <Skeleton animation="wave" variant="rectangular" height={150} />
                <Skeleton animation="wave" variant="rectangular" height={64} />
            </Stack>
            <Stack spacing={1}>
                <Skeleton animation="wave" variant="rectangular" height={45} />
                <Skeleton animation="wave" variant="rectangular" height={150} />
                <Skeleton animation="wave" variant="rectangular" height={64} />
            </Stack>
        </>
    );
}
